import React, { useEffect } from "react";
import NewOrder from "../../components/orderpage/NewOrder";
import Navbar from "../../components/main/Navbar";
import { OrderUseContext } from "../../context/AdminDashboard/OrderContext";
import OrderList from "../../components/orderpage/OrderList";
import { Toaster } from "react-hot-toast";
const Order = () => {
  
  const {
    // countAllPages,
    // changePage,
    getnewOrder,
    getOrder,
    gettext,
    buttonSearch,
  } = OrderUseContext();

  useEffect(() => {
    getnewOrder();
  }, []);

  useEffect(() => {
    getOrder();
    document.title = "سفارش‌ها";
  }, []);

  return (
    <div className="pb-7.5px">
      <Navbar titles={["سفارش‌ها"]} />
      <NewOrder gettext={gettext} buttonSearch={buttonSearch} />
      <OrderList />
      <Toaster />
    </div>
  );
};

export default Order;
